import { useFormik } from "formik";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import {
  COMPONENTS,
  DATE_FORMAT_LIST,
  DATETIME_FORMAT_LIST,
  MODULES,
  NOTIFY_TYPE,
  REMINDER_INTERVAL_SCOPE,
  ROLE_BY_PERMISSIONS,
  TIMEZONE_LIST,
} from "../../../Constant";
import CustomButton from "../../../Components/Atoms/CustomButton";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import {
  getSettingsRequest,
  postSettingsRequest,
  postSettingsResponseClear,
  putSettingsRequest,
} from "../../../Redux/Settings/SettingsActions";
import { CircularProgress } from "@mui/material";
import toast from "react-hot-toast";
import { getUserRequest } from "../../../Redux/GetUser/GetUserActions";
import AvailableStatus from "../../../Components/Atoms/AvailableStatus";
import NoRecords from "../../../Components/Atoms/NoRecord";
import { Delete, Edit } from "@mui/icons-material";
import CustomDialog from "../../../Components/Molecules/CustomDialog";
import ReminderEmails from "./ReminderEmailsForm";
import ConfirmModal from "../../../Components/Molecules/ConfirmModal/Index";
import { hasPermission } from "../../../Utils/getters";
import CustomInput from "../../../Components/Atoms/CustomInput";

const OtherSettingsForm = () => {
  const {
    getSettingsLoading,
    getSettingsResponse,
    postSettingsLoading,
    postSettingsResponse,
  } = useSelector((state) => state.settingsReducer);

  const { getUserResponse } = useSelector((state) => state.user);

  const [smsSidVisible, setSmsSidVisible] = useState(false);
  const [smsAuthTokenVisible, setSmsAuthTokenVisible] = useState(false);

  const formik = useFormik({
    initialValues: {
      time_zone: "",
      date_format: "",
      date_time_format: "",
      reminder_scope: "GLOBAL_LEVEL",
      emails: [],
      sms_account_sid: "",
      sms_auth_token: "",
      sms_from_no: "",
    },
    onSubmit: (values) => {
      if (getSettingsResponse?.data) {
        dispatch(
          putSettingsRequest({
            ...values,
            _id: getSettingsResponse?.data?._id,
          })
        );
      } else {
        dispatch(postSettingsRequest({ ...values }));
      }
    },
    validationSchema: Yup.object().shape({
      time_zone: Yup.string().required("Required"),
      date_format: Yup.string().required("Required"),
      date_time_format: Yup.string().required("Required"),
      sms_account_sid: Yup.string().required("Required"),
      sms_auth_token: Yup.string().required("Required"),
      sms_from_no: Yup.string().required("Required"),
    }),
  });

  const [data, setData] = useState(null);

  const action = data ? "edit" : "new";

  const email_formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: (values) => {
      if (action === "new") {
        const res = [...formik.values.emails, values];
        formik.setFieldValue("emails", res);
      } else {
        const res = [...formik.values.emails];
        res[editIndex] = { ...values };
        formik.setFieldValue("emails", res);
      }
      handleClose();
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email("Invalid email address").required("Required"),
    }),
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (postSettingsLoading) return;
    dispatch(getSettingsRequest());
    dispatch(getUserRequest());
  }, [postSettingsLoading]);

  useEffect(() => {
    if (getSettingsLoading) return;
    if (getSettingsResponse?.data) {
      Object.keys(formik.values).forEach((key) => {
        formik.setFieldValue(key, getSettingsResponse?.data?.[key] || "");
      });
    }
  }, [getSettingsLoading]);

  useEffect(() => {
    if (postSettingsResponse?.success && postSettingsResponse?.message) {
      toast.success(postSettingsResponse?.message);
    } else if (postSettingsResponse?.response?.data) {
      toast.error(postSettingsResponse?.response?.data?.message);
    }
    return () => {
      dispatch(postSettingsResponseClear());
    };
  }, [postSettingsResponse]);

  //

  const [open, setOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const handleOpen = (type, data = null, index = null) => {
    setOpen(true);
    setData(data);
    setEditIndex(index);
  };

  const handleClose = () => {
    setOpen(false);
    setEditIndex(null);
  };

  const handleDelete = (indexToRemove) => {
    const updatedList = formik.values.emails.filter(
      (_item, index) => index !== indexToRemove
    );
    formik.setFieldValue("emails", updatedList);
  };

  const [deleteConfig, setDeleteConfig] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDeleteOpen = () => setDeleteOpen(true);
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  return (
    <>
      <CustomDialog
        maxWidth="md"
        title={data ? "UPDATE REMINDER EMAIL" : "CREATE REMINDER EMAIL"}
        handleClose={() => {
          handleClose();
        }}
        open={open}
      >
        <div>
          <ReminderEmails
            handleClose={handleClose}
            data={data}
            email_formik={email_formik}
          />
        </div>
      </CustomDialog>

      <CustomDialog
        maxWidth="sm"
        title={`S.NO - ${deleteConfig?.s_no}`}
        handleClose={handleDeleteClose}
        open={deleteOpen}
      >
        <ConfirmModal
          message={"Are you sure you want to delete this record ?"}
          subMessage={
            "This will delete this recird permanently, You cannot undo This Action."
          }
          handleSubmit={() => {
            handleDelete(deleteConfig?.delete_index);
            handleDeleteClose();
          }}
          handleClose={handleDeleteClose}
        />
      </CustomDialog>

      <>
        {getSettingsLoading ? (
          <>
            <div className="d-flex align-items-center justify-content-center">
              <CircularProgress size={25} />
            </div>
          </>
        ) : (
          <>
            <>
              <div className="mt-10 d-flex-juscon-sb-align-center mb-10">
                <h6>EMAIL'S MASTER - (Notification process)</h6>
                {hasPermission(
                  [
                    ROLE_BY_PERMISSIONS[MODULES.OTHER_SETTINGS]
                      .CREATE_OTHER_SETTINGS,
                  ],
                  getUserResponse?.data
                ) && (
                  <CustomButton
                    label={"New Email"}
                    size="small"
                    action={"NEW"}
                    onClick={() => handleOpen("new")}
                  />
                )}
              </div>
              <div className="tblWrpr mb-15">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>S.NO</th>
                        <th>EMAIL</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formik.values.emails?.length > 0 ? (
                        formik.values.emails?.map((data, index) => (
                          <tr key={index}>
                            <td> {index + 1}</td>
                            <td> {data?.email}</td>
                            <td>
                              <div className="view">
                                <button
                                  type="button"
                                  onClick={() => {
                                    handleOpen("edit", data, index);
                                  }}
                                >
                                  <Edit />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setDeleteConfig({
                                      ...data,
                                      delete_index: index,
                                      s_no: index + 1,
                                    });
                                    handleDeleteOpen();
                                  }}
                                >
                                  <Delete />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <NoRecords />
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
            <>
              <h6 className="mb-4">OTHER CONFIGURATIONS</h6>
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">Time Zone</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomSelect
                      type="text"
                      name="time_zone"
                      placeholder="Select Time Zone"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.time_zone}
                      formik={formik}
                      maxOptionLength={70}
                      data={TIMEZONE_LIST}
                      errorMsg={
                        formik.touched?.time_zone && formik.errors?.time_zone
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">Date Format</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomSelect
                      type="text"
                      name="date_format"
                      placeholder="Select Time Zone"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.date_format}
                      formik={formik}
                      maxOptionLength={70}
                      data={DATE_FORMAT_LIST}
                      errorMsg={
                        formik.touched?.date_format &&
                        formik.errors?.date_format
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">Date Time Format</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomSelect
                      type="text"
                      name="date_time_format"
                      placeholder="Select Datetime Format"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.date_time_format}
                      formik={formik}
                      maxOptionLength={70}
                      data={DATETIME_FORMAT_LIST}
                      errorMsg={
                        formik.touched?.date_time_format &&
                        formik.errors?.date_time_format
                      }
                    />
                  </div>
                  {/* <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">Reminder Interval Scope</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomSelect
                      type="text"
                      name="reminder_scope"
                      placeholder="Select Reminder Scope"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.reminder_scope}
                      formik={formik}
                      maxOptionLength={70}
                      data={REMINDER_INTERVAL_SCOPE}
                      errorMsg={
                        formik.touched?.reminder_scope &&
                        formik.errors?.reminder_scope
                      }
                    />
                  </div> */}
                </div>
              </div>
            </>
            <>
              <h6 className="mb-4">SMS CONFIGURATIONS</h6>
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">From Number</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomInput
                      name="sms_from_no"
                      placeholder="Enter From Phone No"
                      value={formik.values.sms_from_no}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      formik={formik}
                      type={"text"}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">Account SID</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomInput
                      name="sms_account_sid"
                      placeholder="Enter SMS Account SID"
                      value={formik.values.sms_account_sid}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      component={COMPONENTS.PASSWORD}
                      formik={formik}
                      type={smsSidVisible ? "text" : "password"}
                      endAdornment={
                        <IconButton
                          className="material-symbols-rounded"
                          onClick={() => setSmsSidVisible(!smsSidVisible)}
                        >
                          {smsSidVisible ? "visibility_off" : "visibility"}
                        </IconButton>
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <p className="mb-1">Auth Token</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomInput
                      name="sms_auth_token"
                      placeholder="Enter SMS Auth Token"
                      value={formik.values.sms_auth_token}
                      component={COMPONENTS.PASSWORD}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      formik={formik}
                      type={"password"}
                    />
                  </div>
                </div>
              </div>
            </>
            <div className="d-flex-juscon-flex-end-align-center mb-10">
              {hasPermission(
                [
                  ROLE_BY_PERMISSIONS[MODULES.OTHER_SETTINGS]
                    .CREATE_OTHER_SETTINGS,
                ],
                getUserResponse?.data
              ) && (
                <CustomButton
                  label={"Save"}
                  size="small"
                  disabled={postSettingsLoading}
                  onClick={formik.handleSubmit}
                  action={"SAVE"}
                />
              )}
            </div>
          </>
        )}
      </>
    </>
  );
};
export default OtherSettingsForm;
